import React, { useContext } from "react";
import styled from "react-emotion";
import { FormContext } from "em-form";
// import InputCheckbox from "./InputCheckbox";
// import InputDate from "./InputDate";
// import InputDateRange from "./InputDateRange";
import KaInputRadio from "./KaInputRadio";
// import InputSelect from "./InputSelect";
// import InputStatic from "./InputStatic";
// import InputTags from "./InputTags";
import KaInputText from "./KaInputText";
import useWindowSize from "../../hooks/useWindowSize";
import { cx } from "emotion";
// import InputHtml from "./InputHtml";

function KaInput(props) {
  const form = useContext(FormContext);
  const inputRef = React.createRef();
  const windowSize = useWindowSize();

  const getComponent = type => {
    switch (type) {
      // case "checkbox":
      //   return InputCheckbox;
      // case "yesno":
      //   return InputCheckbox;
      case "radio":
        return KaInputRadio;
      // case "static":
      //   return InputStatic;
      // case "date":
      //   return InputDate;
      // case "date-range":
      //   return InputDateRange;
      // case "tags":
      //   return InputTags;
      // case "select":
      //   return InputSelect;
      // case "html":
      //   return InputHtml;
      default:
        return KaInputText;
    }
  };

  const {
    type = "text",
    disabled,
    style,
    name,
    // onChange,
    inlineBlock = false,
    className,
    scrollToError = null,
  } = props;

  const hasError = form.errors[name];

  const InputComponent = getComponent(type);

  if (scrollToError && hasError && scrollToError === name) {
    window && window.scrollTo(0, inputRef.current.getBoundingClientRect().top + window.scrollY);
  }

  return (
    <div
      style={style}
      className={cx([
        className,
        "form-group",
        `${type}Wrapper`,
        inlineBlock && "inlineBlock",
        disabled && "disabled",
        hasError && "has-error",
        windowSize.isMobile && "touch",
      ])}
    >
      <InputComponent {...props} {...form} onChange={form.onChange} />
    </div>
  );
}

KaInput = styled(KaInput)`
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
    margin: 0;
  }

  label {
    user-select: none;
    font-weight: 400;
    font-size: 14px;
  }

  label:hover {
    cursor: pointer;
  }

  &.disabled label:hover {
    cursor: default;
  }

  &.inlineBlock {
    display: inline-block;
  }

  .labelColoring span {
    color: ${props => props.theme.colors.staticElement};
  }

  .selected .labelColoring span,
  html[data-touch="no-touch"] & .labelColoring:hover span {
    color: ${props => props.theme.colors.primary};
  }

  .labelColoring .svg {
    top: 3px;
    background-color: ${props => props.theme.colors.primaryInverse};
    border: 1px solid ${props => props.theme.colors.staticElement};
    border-radius: 5px;
  }

  html[data-touch="no-touch"] & .labelColoring:hover .svg {
    color: ${props => props.theme.colors.primary};
    background-color: ${props => props.theme.colors.primaryInverse};
    border: 1px solid ${props => props.theme.colors.primary};
    border-radius: 5px;
  }

  .selected .labelColoring .svg {
    color: ${props => props.theme.colors.primaryInverse} !important;
    background-color: ${props => props.theme.colors.primary} !important;
    border: 1px solid ${props => props.theme.colors.primary} !important;
    border-radius: 5px !important;
  }

  .selected .light.labelColoring .svg {
    color: ${props => props.theme.colors.primary} !important;
    background-color: ${props => props.theme.colors.primaryInverse} !important;
    border: 1px solid ${props => props.theme.colors.primary} !important;
    border-radius: 5px !important;
  }

  .disabled .labelColoring .svg {
    border-color: ${props => props.theme.colors.gray} !important;
  }

  .disabled label * {
    cursor: default;
    color: ${props => props.theme.colors.gray};
    border-color: ${props => props.theme.colors.gray};
  }

  input:focus,
  textarea:focus,
  select:focus {
    outline: none;
    outline-style: none;
    box-shadow: none !important;
  }

  input[type="text"],
  input[type="email"],
  input[type="tel"],
  input[type="number"],
  input[type="date"],
  select,
  textarea {
    width: 100%;
    border: 1px solid ${props => props.theme.colors.gray};
    border-radius: 5px;
    border-top-left-radius: 5px !important;
    border-bottom-left-radius: 5px !important;
    padding: 7px 10px;
  }

  .additionalSelect {
    display: inline-block;
    position: relative;
    left: 5px;
  }

  .labelOnLeftTheme .form-control {
    display: inline-block;
  }

  &.has-error,
  &.has-error label,
  span.error {
    padding-left: 5px;
    color: ${props => props.theme.colors.danger} !important;
  }

  &.has-error input:not([role="combobox"]) {
    border: 1px solid ${props => props.theme.colors.danger} !important;
  }

  .icon {
    display: inline-block;
    height: 23px;
    width: 23px;
    ${"" /* margin: 0px 5px; */};
  }

  .control-label span {
    font-weight: normal !important;
  }

  .iconFirst .control-label {
    display: block;
  }

  .checkbox {
    padding-top: 0px;
  }

  .checkbox,
  .radio {
    margin-top: 0px;

    label {
      padding-left: 0px;
    }
  }

  .checkbox .icon {
    width: 23px;
    height: 23px;
    color: #b4b4b4;

    path.border {
      stroke: #b4b4b4;
      fill: ${props => props.theme.colors.primaryInverse};
    }

    path.inner {
      visibility: hidden;
    }
  }

  html[data-touch="no-touch"] & .checkbox:not(.selected):hover .icon {
    path.inner {
      stroke: #b4b4b4;
      visibility: visible;
    }
  }

  .checkbox.disabled .icon,
  .checkbox.disabled:not(.selected):hover .icon {
    cursor: default !important;
    color: #b4b4b4;
  }

  .checkbox.selected .icon {
    path.border {
      stroke: ${props => props.theme.colors.primary};
      fill: ${props => props.theme.colors.primary};
    }

    path.inner {
      visibility: visible;
      color: ${props => props.theme.colors.primaryInverse};
    }
  }

  .radio {
    margin-top: 0px;
  }

  .radio .icon {
    width: 23px;
    height: 23px;
    color: #b4b4b4;

    path.inner {
      visibility: hidden;
    }
  }

  html[data-touch="no-touch"] & .radio:hover .icon {
    path.inner {
      visibility: visible;
    }
  }

  .radio.disabled .icon {
    cursor: default !important;
    color: #b4b4b4;
  }

  .radio.selected {
    path.border,
    path.inner {
      color: ${props => props.theme.colors.primary};
      stroke: ${props => props.theme.colors.primary};
    }

    path.inner {
      visibility: visible;
    }
  }

  .darkBg & .radio .icon {
    width: 18px;
    height: 18px;
    border-radius: 100%;
    background-color: #fff !important;
    background-repeat: no-repeat !important;
    background-position: -1px -1px !important;
  }

  .bggray .labelBackground {
    border-color: ${props => props.theme.colors.greyBackground} !important;
  }

  .bgprimary .labelBackground {
    border-top: 0px none !important;
  }

  .bgprimary label span {
    color: ${props => props.theme.colors.black};
  }

  .money {
    position: relative;
    display: inherit;
  }

  .money input {
    padding-left: 25px !important;
  }

  .money .moneySign {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 12px;
    font-size: 14px;
    z-index: 1;
  }

  /* TEXT INPUT MOVING LABEL */

  @keyframes labelActive {
    from {
      top: 50%;
    }
    to {
      top: 0px;
    }
  }

  @keyframes labelUnactive {
    from {
      top: 0px;
    }
    to {
      top: 50%;
    }
  }

  @keyframes labelActiveTall {
    from {
      top: 20%;
    }
    to {
      top: 0px;
    }
  }

  @keyframes labelUnactiveTall {
    from {
      top: 0px;
    }
    to {
      top: 20%;
    }
  }

  @keyframes labelActiveAboveWhite {
    from {
      top: 50%;
      left: 7px;
      font-size: inherit;
      color: ${props => props.theme.colors.gray};
    }
    to {
      top: -10px;
      left: -2px;
      font-size: 15px;
      color: ${props => props.theme.colors.white};
    }
  }

  @keyframes labelActiveAbove {
    from {
      top: 50%;
      left: 7px;
      font-size: inherit;
      color: ${props => props.theme.colors.gray};
    }
    to {
      top: -10px;
      left: -2px;
      font-size: 15px;
      color: ${props => props.theme.colors.black};
    }
  }

  @keyframes labelUnactiveAbove {
    from {
      top: -10px;
      left: -2px;
      font-size: 15px;
      color: ${props => props.theme.colors.black};
    }
    to {
      top: 50%;
      left: 7px;
      font-size: inherit;
      color: ${props => props.theme.colors.gray};
    }
  }

  @keyframes labelActiveAboveTall {
    from {
      top: 30%;
      left: 7px;
      font-size: inherit;
      color: ${props => props.theme.colors.gray};
    }
    to {
      top: -10px;
      left: -2px;
      font-size: 15px;
      color: ${props => props.theme.colors.black};
    }
  }

  @keyframes labelUnactiveAboveTall {
    from {
      top: -10px;
      left: -2px;
      font-size: 15px;
      color: ${props => props.theme.colors.black};
    }
    to {
      top: 30%;
      left: 7px;
      font-size: inherit;
      color: ${props => props.theme.colors.gray};
    }
  }

  .inputTags .react-tags {
    background: #fff;
    border: 1px solid ${props => props.theme.colors.gray};
    border-radius: 5px;
  }

  .placeholderToLabel {
    margin-bottom: 18px;
    position: relative;
  }

  .placeholderToLabel .labelText {
    z-index: 10;
    position: relative;
  }

  .placeholderToLabel .labelActive .labelBackground {
    width: 100%;
    display: inline-block;
    position: absolute;
    border-top: 4px solid;
    top: 8px;
    border-color: ${props => props.theme.colors.white};
    z-index: 9;
    left: 0px;
    padding-right: 10px;
  }

  .placeholderToLabel .control-label {
    padding-top: 0px;
  }

  .placeholderToLabel label {
    top: 9px;
    left: 7px;
    position: absolute;
    display: inline-block !important;
    animation-duration: 0.3s;
    padding: 0px 5px;
    z-index: 8;
    transform: translateY(-50%);
    color: ${props => props.theme.colors.gray};
  }

  .placeholderToLabel .labelUnactive {
    animation-name: labelUnactive;
    animation-fill-mode: forwards;
  }

  .placeholderToLabel .labelActive {
    animation-name: labelActive;
    animation-fill-mode: forwards;
  }

  .animatedLabelAbove.placeholderToLabel .labelUnactive {
    animation-name: labelUnactiveAbove;
  }

  .animatedLabelAbove.placeholderToLabel .labelActive {
    animation-name: labelActiveAbove;
  }

  .animatedLabelAbove.placeholderToLabel.darkBg .labelActive {
    animation-name: labelActiveAboveWhite;
  }

  .tall.placeholderToLabel .labelUnactive {
    animation-name: labelUnactiveTall;
  }

  .tall.placeholderToLabel .labelActive {
    animation-name: labelActiveTall;
  }

  .tall.animatedLabelAbove.placeholderToLabel .labelUnactive {
    animation-name: labelUnactiveAboveTall;
  }

  .tall.animatedLabelAbove.placeholderToLabel .labelActive {
    animation-name: labelActiveAboveTall;
  }

  .timeInput {
    position: relative;
    top: -15px;
  }

  .timeInput label {
    position: relative;
    top: 3px;
  }

  .buttonCancel {
    position: relative;
    top: 7px;
  }

  .inputDateRoot .SingleDatePickerInput {
    border-color: #aaa;
    border-radius: 5px;
    padding-bottom: 1px;
  }

  .inputDateRoot .DateRangePickerInput {
    padding-top: 0px;
    padding-bottom: 0px;
    border-radius: 5px;
  }

  .inputDateRoot .SingleDatePicker {
    width: 100%;
  }

  .inputDateRoot .DateInput {
    width: inherit;
    padding-top: 0px;
    padding-bottom: 1px;
    font-size: 15px;
    top: 1px;
    border-radius: 5px;
    padding-left: 1px;
  }

  .inputDateRoot .SingleDatePickerInput__calendar-icon {
    width: inherit;
    padding-top: 7px;
    padding-bottom: 7px;
  }

  .inputDateRangeRoot .DateRangePickerInput {
    border: 0px none;
  }

  .DateRangePicker__picker {
    z-index: 99 !important;
  }

  .inputDateRangeRoot .DateInput {
    border: 1px solid #aaa;
    border-radius: 5px;
    margin-right: 20px;
    height: 34px;
  }

  .inputDateRangeRoot .DateRangePickerInput__arrow {
    margin-right: 10px;
  }

  .inputDateRangeRoot .DateRangePickerInput__calendar-icon {
    padding-left: 0px;
    margin-left: 0px;
    padding: 0px;
  }

  .inputDateRangeRoot .DateRangePickerInput__clear-dates {
    text-decoration: underline;
    padding: 0px;
    border-radius: 0px;
  }

  .dateRangeSeparator {
    display: inline-block;
    margin: 0px 10px;
  }

  .typeYesNo {
    border: 1px solid #ccc;
    border-left: none;
  }

  .typeYesNo,
  .typeYesNo span {
    cursor: pointer;
    display: inline-block;
  }

  &.yesnoWrapper label {
    display: inline-block !important;
    position: relative;
    top: 3px;
  }

  .typeYesNo span {
    border-left: 1px solid #ccc;
    text-align: center;
    text-transform: uppercase;
    width: 48px;
    font-size: 12px;
    padding: 4px;
    color: ${props => props.theme.colors.black};
    background-color: ${props => props.theme.colors.primaryInverse};
  }

  .typeYesNo .selected {
    color: ${props => props.theme.colors.primaryInverse};
    background-color: ${props => props.theme.colors.primary};
  }

  .react-tags {
    position: relative;
    padding: 6px 0 0 6px;
    border: 1px solid #f2f2f2;
    border-radius: 5px;

    font-size: 1em;
    line-height: 1.2;

    cursor: text;
  }
  .react-tags ::placeholder {
    color: #a2a2a2;
  }

  .react-tags.is-focused {
  }

  .react-tags__selected {
    display: inline;
  }

  .react-tags__selected-tag {
    display: inline-block;
    box-sizing: border-box;
    margin: 0 6px 6px 0;
    padding: 6px 8px;
    border: 1px solid #d1d1d1;
    border-radius: 2px;
    background: #f1f1f1;

    font-size: inherit;
    line-height: inherit;
  }

  ${"" /* .react-tags__selected-tag:after {
    content: "U+2715";
    color: #aaa;
    margin-left: 8px;
  } */} .react-tags__selected-tag:hover,
  .react-tags__selected-tag:focus {
    border-color: #b1b1b1;
  }

  .react-tags__search {
    display: inline-block;

    padding: 7px 2px;
    margin-bottom: 6px;

    max-width: 100%;
  }

  @media screen and (min-width: 30em) {
    .react-tags__search {
      position: relative;
    }
  }

  .react-tags__search input {
    max-width: 100%;

    margin: 0;
    padding: 0;
    border: 0;
    outline: none;

    font-size: inherit;
    line-height: inherit;
  }

  .react-tags__search input::-ms-clear {
    display: none;
  }

  .react-tags__suggestions {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    z-index: 9;
  }

  @media screen and (min-width: 30em) {
    .react-tags__suggestions {
      width: 240px;
    }
  }

  .react-tags__suggestions ul {
    margin: 4px -1px;
    padding: 0;
    list-style: none;
    background: white;
    border: 1px solid #d1d1d1;
    border-radius: 2px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  }

  .react-tags__suggestions li {
    border-bottom: 1px solid #ddd;
    padding: 6px 8px;
  }

  .react-tags__suggestions li mark {
    text-decoration: underline;
    background: none;
    font-weight: 600;
    margin: 0px;
    padding: 0px;
  }

  .react-tags__suggestions li:hover {
    cursor: pointer;
    background: #eee;
  }

  .react-tags__suggestions li.is-active {
    background: #b7cfe0;
  }

  .react-tags__suggestions li.is-disabled {
    opacity: 0.5;
    cursor: auto;
  }
`;

export default KaInput;

// const onChangeOld = event => {
//   const {
//     name: nameFromProps,
//     // multiple,
//     store,
//     onChange,
//     onClick,
//     onClickBefore,
//     type,
//   } = props;
//   const name = event.target.name || nameFromProps;

//   if (onClickBefore) {
//     const result = onClickBefore(event);

//     if (!result) return;
//   }

//   let value = event.target.value;

//   if (type === "checkbox") {
//     value =
//       event.target.value === "on" || (!event.target.value && event.target.checked)
//         ? event.target.checked
//         : event.target.value;
//   }

//   if (type === "money") {
//     value = value.replace(/[^0-9]/g, "");
//   } else if (type === "number") {
//     value = Number(value);
//   }

//   if (name.slice(-2) === "[]") {
//     const nameNormalized = name.replace("[]", "");

//     const array = [...(store.get(nameNormalized) || [])];

//     if (event.target.checked === false) {
//       array.splice(array.indexOf(value), 1);
//     } else {
//       array.push(value);
//     }

//     store && store.setArray(nameNormalized, array);
//   } else {
//     store && store.set(name, value);
//   }

//   // const fixedEvent = { ...event, target: { name: event.target.name, value: value } };

//   // event.target.value = value;

//   if (type === "checkbox") {
//     value = ["on", "true", true].includes(event.target.checked);
//   }

//   onChange && onChange({ target: { name, value } });
//   onClick && onClick({ target: { name, value } });

//   return true;
// };
